export default "<p>site-console works!</p>\r\n"